import moment from "moment";

export const getPieceDateReport = ({ startDateTimeISO, endDateTimeISO }) => {
  const momentPieceStartDate = moment(new Date(startDateTimeISO));
  const momentPieceEndDate = moment(new Date(endDateTimeISO));
  const pieceStartDate = startDateTimeISO
    ? momentPieceStartDate.format("LL")
    : null;
  const pieceEndDate = endDateTimeISO ? momentPieceEndDate.format("LL") : null;
  const timeTaken =
    pieceStartDate !== null && pieceEndDate !== null
      ? momentPieceEndDate.diff(momentPieceStartDate, "days")
      : null;
  const result = { pieceStartDate, pieceEndDate, timeTaken };

  return result;
};
